<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <router-link to="/posts/add_post" class="btn add">
              <i class="fas fa-plus ms-1"></i>
              إضافة خبر جديد
            </router-link>

            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh"
                    v-model="searchValue"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>
            <table v-show="this.posts.length > 0" class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">الرقم</th>
                  <th scope="col">عنوان</th>
                  <th scope="col">النوع</th>
                  <th style="width: 40%" scope="col">الوصف</th>
                  <th style="width: 30%" scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(post, index) in this.posts" :key="index">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ post.title }}</td>
                  <td>{{ filterItems(post.post_type) }}</td>
                  <td>{{ post.short_description }}</td>
                  <td>
                    <router-link
                      class="btn view"
                      :to="{
                        name: 'view_post',
                        params: { id: post.post_id },
                      }"
                    >
                      <i class="fas fa-folder ms-1"></i>
                      عرض
                    </router-link>
                    <router-link
                      class="btn edit me-2"
                      :to="{
                        name: 'edit_post',
                        params: { id: post.post_id },
                      }"
                    >
                      <i class="fas fa-edit"></i>
                      تعديل
                    </router-link>

                    <button
                      class="btn me-2 delete"
                      @click="this.deleteSelectedPost(post)"
                    >
                      <i class="fas fa-trash-alt ms-2"></i>
                      حذف
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-show="
                (!this.isloading && !this.posts) || this.posts.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد أخبار حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";
// Delete from firebase Storage
import { deleteFileFromUrl } from "@/firebase/firebase_storage";
export default {
  data() {
    return {
      currentView: "الاخبار",
      posts: [],
      // Loading
      isloading: false,
      firstLoad: "",
      // Search
      searchValue: "",
    };
  },
  methods: {
    ...mapActions("postsModule", ["fetchPosts", "deletePost", "tryPagination"]),
    //-----------------------------------------------
    // Sort
    sortByCreateDate() {
      this.posts.sort(
        (a, b) => b.created_date.seconds - a.created_date.seconds
      );
    },
    sortByName() {
      this.posts.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    //-----------------------------------------------

    //-----------------------------------------------
    // Search
    getDocBySeacrh() {
      setTimeout(() => {
        var re = new RegExp(this.searchValue + ".+$", "i");
        this.posts = this.getPosts.filter(
          (item) => item.title.search(re) != -1
        );
      }, 800);
    },
    //-----------------------------------------------

    //--------------------------------------------
    // Get Post By ID
    // Delete Post
    deleteSelectedPost(post) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا الخبر؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الخبر بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deletePost(post.post_id);
          deleteFileFromUrl(post.thumbnail_url);
          deleteFileFromUrl(post.file_url);
        }
      });
      console.log(post);
    },

    //--------------------------------------------
    filterItems(type) {
      switch (type) {
        case 1:
          return "نص";
        case 2:
          return "صورة";
        case 3:
          return "ملف";
        case 4:
          return "فيديو";
      }
    },
  },
  async created() {
    if (this.isFirstLoad) await this.fetchPosts();
    this.tryPagination();
  },
  computed: {
    ...mapGetters("postsModule", ["getPosts", "isLoading", "isFirstLoad"]),
  },
  mounted() {
    this.posts = this.getPosts;
    this.isloading = this.isLoading;
    this.firstLoad = this.isFirstLoad;
  },
  watch: {
    getPosts() {
      this.posts = this.getPosts;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
  },
};
</script>

<style>
</style>